import { Text } from "@chakra-ui/react";

export default function RouteNotFound() {
    return (
        <Text pl={2} pt={5} fontWeight={'bold'} textAlign={'center'}>erreur 404 - page inexistante</Text>
    )
}